module.exports = __webpack_public_path__ + "img/patch-minus.fcbf9bed.svg";